/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Your_ScoreInputs */



/**
* | output |
* | --- |
* | "Your score:" |
*
* @param {Tournament_Your_ScoreInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_your_score = /** @type {((inputs?: Tournament_Your_ScoreInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Your_ScoreInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Votre score :")
	if (locale === "es") return /** @type {LocalizedString} */ ("Su puntuación:")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Sua pontuação:")
	if (locale === "it") return /** @type {LocalizedString} */ ("Il tuo punteggio:")
	return /** @type {LocalizedString} */ ("Your score:")
});